;(function () {
  'use strict'

  angular
    .module('contrast.tooltips')
    .directive('csShowTooltipOnTextOverflow', csShowTooltipOnTextOverflow)

  function csShowTooltipOnTextOverflow() {
    'ngInject'

    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var el = element[0]
        scope.$watch(
          function () {
            return el.parentNode.offsetWidth
          },
          function () {
            if (el.parentNode.offsetWidth + 10 < el.parentNode.scrollWidth) {
              attrs.tooltipEnable = 'true'
            } else {
              attrs.tooltipEnable = 'false'
            }
          }
        )
      }
    }
  }
})()
